<div class="close">
    <button class="btn btn-secondary-icon" (click)="onClose()">
        <span class="cm-icon cm-icon-close" aria-hidden="true"></span>
    </button>
</div>
<ng-content></ng-content>
